import { FilterComponentProps } from "@Pages/Search/components/FilterSection/components/ActiveFilterComponent/types";
import RadioChip from "../RadioChip";
import styles from "./moveInMonth.module.scss";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { MONTHS as months } from "constants/index";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import transformDateData from "@Pages/Search/utils/transformDatetoArray";

const MoveInMonth = ({ value, dispatch, dynamiCount }: FilterComponentProps<string>) => {
  const isNewMoveInFilter = false;
  const MONTHS_TO_SHOW = isNewMoveInFilter ? 12 : 7;
  const currMonthIdx = new Date()?.getMonth();
  const currYear = String(new Date()?.getFullYear()); // Current year in YY format

  const handleSelectedValue = (val = "") => {
    gtagEventEmitter({
      action: "SP_filter_subsection_filter_value_selected",
      category: "SP_filter_subsection",
      value: "Move in Month",
    });
    dispatch({ type: "moveInMonth", payload: val });
  };

  const updatedMonthsOfCurrYear =
    months?.slice(currMonthIdx, months.length)?.map((month) => ({
      label: `${month} ${currYear?.slice(-2)}`,
      value: `${month}-${currYear}`,
    })) || [];

  const updatedMonthsOfNextYear =
    months?.slice(0, currMonthIdx)?.map((month) => ({
      label: `${month} ${String(Number(currYear) + 1)?.slice(-2)}`,
      value: `${month}-${Number(currYear) + 1}`,
    })) || [];

  const updatedMonths =
    [...updatedMonthsOfCurrYear, ...updatedMonthsOfNextYear].slice(0, MONTHS_TO_SHOW) || [];
  const { t } = useTranslationHook();
  const dateData = transformDateData(dynamiCount || {});

  return (
    <div className={styles.moveInMonthContainer}>
      {isNewMoveInFilter && !isNewMoveInFilter && dynamiCount
        ? dateData.map((month) => (
            <RadioChip
              name="moveInMonth"
              key={month.moveInMonth}
              label={t(month.value)}
              value={month.moveInMonth}
              isSelected={value === month.moveInMonth}
              setSelectedValue={handleSelectedValue}
            />
          ))
        : updatedMonths.map((month) => (
            <RadioChip
              name="moveInMonth"
              key={month.label}
              label={t(month.label)}
              value={month.value}
              isSelected={value === month.value}
              setSelectedValue={handleSelectedValue}
            />
          ))}
    </div>
  );
};

export default wrapperHOC(MoveInMonth, {
  componentName: "MoveInMonth-FilterSubsection-SearchListDesktop-SearchPage",
  showForChina: true,
});
